import { useCallback } from 'react';
import { useLocale } from 'src/hooks/use-locale';

export const useGetPaymentScheduleTitles = () => {
  const t = useLocale();

  return useCallback(
    (monthCount: number) => {
      switch (monthCount) {
        case 0:
          return t('tabbyCard.Today');
        case 1:
          return t('x_months_one', { monthCount });
        default:
          return t('x_months_other', { monthCount });
      }
    },
    [t]
  );
};
